var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9999 20.0005C12.9997 20.7277 12.6049 21.3976 11.9687 21.75C11.3326 22.1024 10.5553 22.0818 9.93864 21.6962L5.93697 19.1952C5.35173 18.8298 4.99626 18.1884 4.99658 17.4984V6.00008C4.99668 5.27277 5.39141 4.60278 6.02755 4.2502C6.66369 3.89762 7.44105 3.91798 8.05786 4.30337L12.0595 6.80441C12.6448 7.16982 13.0002 7.81117 12.9999 8.50112V20.0005Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0036 10.542L18.0884 13.4572",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0036 13.4572L18.0884 10.542",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.003 6.9975V5.99708C20.0031 5.46638 19.7924 4.95738 19.4171 4.58212C19.0418 4.20686 18.5328 3.9961 18.0021 3.99625H6.99756",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20.0029H18.0021C18.5328 20.003 19.0418 19.7923 19.417 19.417C19.7923 19.0418 20.0031 18.5328 20.0029 18.0021V17.0016",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.951a16157ed5c6bcf06fa580e69b7070.svg";
export { ForwardRef as ReactComponent };